import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import Mat3 from "../../helpers/Mat3.js";

/**
 * Transform layer: make skew for each frame
 */
export default class CanvasSkew extends AbstractCanvasTransformTool {
	/**
	 * @param {boolean} isLeft
	 * @param {boolean} isFloor
	 */
	constructor(isLeft, isFloor) {
		super();

		/**
		 * @type {boolean}
		 * @private
		 */
		this._isLeft = isLeft;

		/**
		 * @type {boolean}
		 * @private
		 */
		this._isFloor = isFloor;
	}

	/**
	 * @param {Mat3} mat
	 */
	_transformImage(ctx, mat, frameIndex) {
		if (!this._isFloor) {
			mat.scale(0.7, 1);
			mat.skew(0, this._isLeft ? -0.8 : 0.8);

			// for batman
			//mat.scale(0.9, 1);
			//mat.skew(0, this._isLeft ? -0.23 : 0.23);

			// for pirate banner
			//mat.scale(0.4, 1);
			//mat.skew(0, this._isLeft ? -1.8 : 1.8);
		}
	}
}
